module.exports = __webpack_public_path__ + "images/emoji/bridge_at_night.daf4999eacdcbeb965ad.png";